import { render, staticRenderFns } from "./buttonHover.vue?vue&type=template&id=08947f60&scoped=true"
import script from "./buttonHover.vue?vue&type=script&lang=js"
export * from "./buttonHover.vue?vue&type=script&lang=js"
import style0 from "./buttonHover.vue?vue&type=style&index=0&id=08947f60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08947f60",
  null
  
)

export default component.exports